import { api } from "@/lib/api";

export const lawyerApi = api;

export const fetchDashboard = () => lawyerApi.get("/lawyer/dashboard").then((r) => r.data);
export const fetchAvailabilityStatus = () => lawyerApi.get("/lawyer/availability/status").then((r) => r.data);
export const fetchBookingAlerts = (since) => lawyerApi.get("/lawyer/alerts", { params: since ? { since } : {} }).then((r) => r.data);
export const fetchVerificationProgress = () => lawyerApi.get("/lawyer/verification/progress").then((r) => r.data);
export const fetchProfile = () => lawyerApi.get("/lawyer/me").then((r) => r.data);
export const updateProfile = (payload) => lawyerApi.patch("/lawyer/me", payload).then((r) => r.data);
export const uploadProfilePhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  // Override the client's JSON default so axios sets the multipart boundary.
  return lawyerApi.post("/lawyer/profile/photo", fd,
    { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const setAvailability = (payload) => lawyerApi.post("/lawyer/availability", payload).then((r) => r.data);
export const ackListingCelebration = () => lawyerApi.post("/lawyer/listing-celebration/ack").then((r) => r.data);

export const fetchConsultations = (params) => lawyerApi.get("/lawyer/consultations", { params }).then((r) => r.data);
export const acceptConsultation = (cid) => lawyerApi.post(`/lawyer/consultations/${cid}/accept`).then((r) => r.data);
export const rejectConsultation = (cid, reason = "") => lawyerApi.post(`/lawyer/consultations/${cid}/reject`, { reason }).then((r) => r.data);
export const markNoShow = (cid) => lawyerApi.post(`/lawyer/consultations/${cid}/no-show`).then((r) => r.data);

export const fetchEarnings = (params) => lawyerApi.get("/lawyer/earnings", { params }).then((r) => r.data);
export const fetchEarningDetail = (cid) => lawyerApi.get(`/lawyer/earnings/${cid}`).then((r) => r.data);

// Pricing Levels
export const fetchLawyerPricing = () => lawyerApi.get("/lawyer/pricing").then((r) => r.data);
export const fetchLawyerPricingHistory = () => lawyerApi.get("/lawyer/pricing/history").then((r) => r.data);
export const applyPricingLevel = (payload) => lawyerApi.post("/lawyer/pricing/apply", payload).then((r) => r.data);

// Phase-3B: Availability Pulse
export const startPulse = (duration_minutes = 15, message = "") =>
  lawyerApi.post("/lawyer/pulse", { duration_minutes, message }).then((r) => r.data);
export const stopPulse = () => lawyerApi.delete("/lawyer/pulse").then((r) => r.data);

// Phase-3B: AI memo background job
export const enqueueAiSummary = (cid) =>
  lawyerApi.post(`/consultations/${cid}/ai-summary/enqueue`).then((r) => r.data);
export const aiSummaryStatus = (cid) =>
  lawyerApi.get(`/consultations/${cid}/ai-summary/status`).then((r) => r.data);

// Live runtime + reviews + AI summary
export const fetchPushConfig = () => lawyerApi.get("/lawyer/push/config").then((r) => r.data);
export const savePushSubscription = (subscription) => lawyerApi.post("/lawyer/push/subscribe", { subscription }).then((r) => r.data);
export const removePushSubscription = (endpoint) => lawyerApi.delete("/lawyer/push/subscribe", { data: { endpoint } }).then((r) => r.data);
export const sendPushTest = () => lawyerApi.post("/lawyer/push/test").then((r) => r.data);
export const startConsultation = (cid) => lawyerApi.post(`/consultations/${cid}/start`).then((r) => r.data);
export const completeConsultation = (cid) => lawyerApi.post(`/consultations/${cid}/complete`).then((r) => r.data);
export const fetchLawyerReviews = (params) => lawyerApi.get("/lawyer/reviews", { params }).then((r) => r.data);
export const generateAiSummary = (cid) => lawyerApi.post(`/consultations/${cid}/ai-summary`).then((r) => r.data);
export const updateAiSummary = (cid, payload) => lawyerApi.patch(`/consultations/${cid}/ai-summary`, payload).then((r) => r.data);
export const readAiSummary = (cid) => lawyerApi.get(`/consultations/${cid}/ai-summary`).then((r) => r.data);
export const fetchRuntimeState = (cid) => lawyerApi.get(`/consultations/${cid}/runtime`).then((r) => r.data);


// Payouts (Cashfree-backed; provider-neutral on the wire).
export const fetchPayoutBalance = () =>
  lawyerApi.get("/lawyer/payouts/balance").then((r) => r.data);
export const fetchMyPayouts = (params) =>
  lawyerApi.get("/lawyer/payouts", { params }).then((r) => r.data);
export const requestPayout = ({ amount_paise, idempotency_key, notes }) =>
  lawyerApi
    .post("/lawyer/payouts", { amount_paise, notes }, {
      headers: { "Idempotency-Key": idempotency_key },
    })
    .then((r) => r.data);
export const cancelPayout = (payout_id, reason = "") =>
  lawyerApi.post(`/lawyer/payouts/${payout_id}/cancel`, { reason }).then((r) => r.data);

// Legal Consultation Record (LCR) — lawyer authoring
export const fetchLcr = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/lcr`).then((r) => r.data);
export const patchLcr = (cid, payload) =>
  lawyerApi.patch(`/lawyer/consultations/${cid}/lcr`, payload).then((r) => r.data);
export const publishLcr = (cid) =>
  lawyerApi.post(`/lawyer/consultations/${cid}/lcr/publish`).then((r) => r.data);
export const fetchLcrVersions = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/lcr/versions`).then((r) => r.data);
export const addLcrAttachment = (cid, payload) =>
  lawyerApi.post(`/lawyer/consultations/${cid}/lcr/attachments`, payload).then((r) => r.data);
export const removeLcrAttachment = (cid, aid) =>
  lawyerApi.delete(`/lawyer/consultations/${cid}/lcr/attachments/${aid}`).then((r) => r.data);
export const fetchPreviousRecords = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/previous-records`).then((r) => r.data);
export const requestLcrAccess = ({ lcr_id, consultation_id, reason }) =>
  lawyerApi.post(`/lawyer/lcr-access-requests`, { lcr_id, consultation_id, reason }).then((r) => r.data);

// LCR AI helpers (Emergent LLM Key)
export const lcrAiDraft = (cid) =>
  lawyerApi.post(`/lawyer/consultations/${cid}/lcr/ai/draft`).then((r) => r.data);
export const lcrAiImprove = (cid, field, text) =>
  lawyerApi.post(`/lawyer/consultations/${cid}/lcr/ai/improve`, { field, text }).then((r) => r.data);
export const lcrAiSuggest = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/lcr/ai/suggestions`).then((r) => r.data);
export const lcrReadiness = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/lcr/readiness`).then((r) => r.data);

// LCR attachments upload + preview + templates
export const uploadLcrAttachment = (cid, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return lawyerApi
    .post(`/lawyer/consultations/${cid}/lcr/attachments/upload`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const fetchLcrPreview = (cid) =>
  lawyerApi.get(`/lawyer/consultations/${cid}/lcr/preview`).then((r) => r.data);
export const fetchLcrTemplates = () =>
  lawyerApi.get(`/lawyer/lcr-templates`).then((r) => r.data);
export const saveLcrTemplate = (payload) =>
  lawyerApi.post(`/lawyer/lcr-templates`, payload).then((r) => r.data);
export const deleteLcrTemplate = (tid) =>
  lawyerApi.delete(`/lawyer/lcr-templates/${tid}`).then((r) => r.data);
